export const themeBackground = "#f1ece5";
export const themeForeground = "#1e2126";
export const themeCard = "#eae3da";
export const themeCardForeground = "#1e2126";
export const themePopover = "#f1ece5";
export const themePopoverForeground = "#1e2126";
export const themePrimary = "#f7713f";
export const themePrimaryForeground = "#fafaf9";
export const themeSecondary = "#f1c05b";
export const themeSecondaryForeground = "#1e2126";
export const themeTertiary = "#3f86f2";
export const themeTertiaryForeground = "#fafaf9";
export const themeMuted = "#eae3da";
export const themeMutedForeground = "#78716c";
export const themeAccent = "#eae3da";
export const themeAccentForeground = "#1e2126";
export const themeDestructive = "#e11d48";
export const themeDestructiveForeground = "#fafaf9";
export const themeBorder = "#cfc9bf";
export const themeInput = "#cfc9bf";
export const themeRing = "#f7713f";
export const themeRadius = "0.5rem";
export const themeChart1 = "#e34234";
export const themeChart2 = "#29a39b";
export const themeChart3 = "#1e4b5f";
export const themeChart4 = "#dbc11e";
export const themeChart5 = "#f1701f";

export const screen_sm = 640;
export const screen_md = 768;
export const screen_lg = 1024;
export const screen_xl = 1280;
export const screen_xl2 = 1536;
